import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InteractiveMapListing.css';
import React, { useEffect, useRef, useState } from 'react';
import ListingItem from './components/ListingItem';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import useMobile from '../../../utils/useMobile';
import { getItemColor } from './utils/getItemColor';
import { paginate } from './utils/paginate';
import { canUseDOM } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var transition = '0.3s linear';
var InteractiveMapListing = function InteractiveMapListing(_ref) {
  var listingItems = _ref.listingItems,
    rtl = _ref.rtl,
    noItemsDictionary = _ref.noItemsDictionary,
    defaultTypeValues = _ref.defaultTypeValues,
    viewAsListingDictionary = _ref.viewAsListingDictionary,
    viewAsMapDictionary = _ref.viewAsMapDictionary,
    listingTitleCommonDictionary = _ref.listingTitleCommonDictionary,
    listingTitleSelectedDictionary = _ref.listingTitleSelectedDictionary,
    chosenTypes = _ref.chosenTypes,
    mainHitsPerPage = _ref.mainHitsPerPage,
    activeListingItemId = _ref.activeListingItemId,
    loading = _ref.loading,
    analytics = _ref.analytics,
    params = _ref.params,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    viewMoreAsListingDictionary = _ref.viewMoreAsListingDictionary,
    hits = _ref.hits,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    toggleMobileListingView = _ref.toggleMobileListingView,
    _ref$mapModalColor = _ref.mapModalColor,
    mapModalColor = _ref$mapModalColor === void 0 ? '' : _ref$mapModalColor;
  var isMobile = useMobile(769);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    listingView = _React$useState2[0],
    setListingView = _React$useState2[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    carouselItems = _useState4[0],
    setCarouselItems = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  var loaderRef = useRef(null);
  var moveToActiveSlideButton = React.useRef(null);
  var activeSlideIndex = React.useRef(null);
  React.useEffect(function () {
    setItems(paginate(isMobile ? hits : listingItems, Number(mainHitsPerPage), 1));
    var slicedItems = listingItems && listingItems.length ? listingItems.slice(0, 14) : [];
    slicedItems.push({});
    setCarouselItems(slicedItems);
  }, []);
  React.useEffect(function () {
    activeSlideIndex.current = 0;
    setItems(paginate(isMobile ? hits : listingItems, Number(mainHitsPerPage), 1));
    var slicedItems = listingItems && listingItems.length ? listingItems.slice(0, 14) : [];
    slicedItems.push({});
    setCarouselItems(slicedItems);
    if (moveToActiveSlideButton.current) {
      setTimeout(function () {
        moveToActiveSlideButton.current.click();
      }, 10);
    }
  }, [listingItems, hits]);
  React.useEffect(function () {
    var filteredSlicedItems = carouselItems.filter(function (el, index) {
      return activeListingItemId === el.objectID;
    });
    if (filteredSlicedItems.length) {
      carouselItems.forEach(function (el, index) {
        if (activeListingItemId === el.objectID) {
          activeSlideIndex.current = index;
          if (moveToActiveSlideButton.current) {
            moveToActiveSlideButton.current.click();
          }
        }
      });
    } else {
      activeSlideIndex.current = carouselItems.length - 1;
      if (moveToActiveSlideButton.current) {
        moveToActiveSlideButton.current.click();
      }
    }
  }, [activeListingItemId]);
  var renderItems = function renderItems() {
    if (items && items.length) {
      return items.map(function (el, index) {
        return /*#__PURE__*/React.createElement(ListingItem, {
          rtl: rtl,
          key: "".concat(el.objectID),
          item: el,
          isActiveItem: activeListingItemId === el.objectID,
          color: withMapModalView ? mapModalColor : getItemColor(el, defaultTypeValues),
          isCarousel: false,
          analytics: analytics,
          params: params,
          getActivePopupOnMap: getActivePopupOnMap,
          activeTopPicks: activeTopPicks,
          toggleActiveTopPicks: toggleActiveTopPicks
        });
      });
    }
    return [];
  };
  var renderItemsForCarousel = function renderItemsForCarousel() {
    var LastNode = /*#__PURE__*/React.createElement("div", {
      className: "m114-last-carousel-node"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "m114-last-carousel-node__button",
      onClick: function onClick() {
        if (canUseDOM && !listingView) {
          window.scrollTo(0, 0);
        }
        toggleOverflowOnBody();
        if (toggleMobileListingView) {
          toggleMobileListingView(true);
        }
        setListingView(true);
        tealiumClickFunc(tealiumMergeClickData(analytics['mapButtonAnalytics'], params), viewMoreAsListingDictionary);
      }
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18.992",
      height: "14",
      viewBox: "0 0 18.992 14"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group_15417",
      "data-name": "Group 15417",
      transform: "translate(-122.531 -775.5)"
    }, /*#__PURE__*/React.createElement("line", {
      id: "Line_250",
      "data-name": "Line 250",
      x2: "12",
      transform: "translate(128.523 776.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_251",
      "data-name": "Line 251",
      x2: "7",
      transform: "translate(128.523 782.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_252",
      "data-name": "Line 252",
      x2: "10",
      transform: "translate(128.523 788.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_253",
      "data-name": "Line 253",
      x1: "0.992",
      transform: "translate(123.531 776.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_254",
      "data-name": "Line 254",
      x1: "0.992",
      transform: "translate(123.531 782.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_255",
      "data-name": "Line 255",
      x1: "0.992",
      transform: "translate(123.531 788.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }))), viewMoreAsListingDictionary));
    if (carouselItems && carouselItems.length) {
      return carouselItems.map(function (el, index) {
        if (index === carouselItems.length - 1) {
          return LastNode;
        } else {
          return /*#__PURE__*/React.createElement(ListingItem, {
            rtl: rtl,
            key: "".concat(el.objectID),
            item: el,
            isActiveItem: activeListingItemId === el.objectID,
            color: withMapModalView ? mapModalColor : getItemColor(el, defaultTypeValues),
            isCarousel: true,
            analytics: analytics,
            params: params,
            activeTopPicks: activeTopPicks,
            toggleActiveTopPicks: toggleActiveTopPicks,
            getActivePopupOnMap: getActivePopupOnMap
          });
        }
      });
    }
    return [];
  };
  var selectedTitle = withMapModalView ? "".concat(listingTitleSelectedDictionary, " ( ").concat(isMobile ? hits.length.toString() : listingItems.length.toString(), ") ") : "".concat(listingTitleSelectedDictionary.replace('{count}', "(".concat(isMobile ? hits.length.toString() : listingItems.length.toString(), ")")));
  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "m114-im-listing__whole-list ".concat(listingView ? 'visible' : '', "  ").concat(withMapModalView ? 'modal-view' : '')
    }, /*#__PURE__*/React.createElement("span", {
      className: "title"
    }, chosenTypes.length ? selectedTitle : "".concat(listingTitleCommonDictionary)), renderItems(), /*#__PURE__*/React.createElement("div", {
      ref: loaderRef,
      style: {
        paddingBottom: '50px'
      }
    })), isMobile && /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
      var renderCarousel = _ref2.renderCarousel,
        renderPreviousButton = _ref2.renderPreviousButton,
        renderNextButton = _ref2.renderNextButton,
        renderDots = _ref2.renderDots,
        state = _ref2.state,
        moveToSlide = _ref2.moveToSlide;
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItemsForCarousel(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 10000,
              min: 1200
            },
            items: 1
          },
          tabletLarge: {
            breakpoint: {
              max: 1199,
              min: 768
            },
            items: 1
          },
          tablet: {
            breakpoint: {
              max: 767,
              min: 480
            },
            items: 1
          },
          mobile: {
            breakpoint: {
              max: 479,
              min: 0
            },
            items: 1
          }
        },
        containerClass: ''
      }), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          moveToSlide(activeSlideIndex.current);
        },
        type: "button",
        ref: moveToActiveSlideButton,
        className: "d-none"
      }, "move to slide ", activeSlideIndex.current));
    }));
  };
  var renderViewAsList = isMobile && listingItems.length;
  var fetchData = function fetchData() {
    if (isLoading) return;
    var itemsToCompare = isMobile ? hits : listingItems;
    var newData = paginate(itemsToCompare, Number(mainHitsPerPage), page + 1);
    setItems([].concat(_toConsumableArray(items), _toConsumableArray(newData)));
    setIsLoading(false);
    setPage(function (prevIndex) {
      return prevIndex + 1;
    });
  };
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      var target = entries[0];
      if (target.isIntersecting) {
        var itemsToCompare = isMobile ? hits : listingItems;
        if (items.length !== itemsToCompare.length) {
          fetchData();
        } else {
          setPage(1);
        }
      }
    });
    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return function () {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [fetchData]);
  var toggleOverflowOnBody = function toggleOverflowOnBody() {
    var bodyElement = canUseDOM ? document.querySelector('body') : null;
    var htmlElement = canUseDOM ? document.querySelector('html') : null;
    var breadcrumb = canUseDOM ? document.querySelector('.breadcrumb-nav') : null;
    if (bodyElement) {
      if (!listingView) {
        bodyElement.classList.add('prevent-scroll');
      } else {
        bodyElement.classList.remove('prevent-scroll');
      }
    }

    //fix for ios devices
    if (htmlElement) {
      if (!listingView) {
        htmlElement.classList.add('prevent-scroll');
      } else {
        htmlElement.classList.remove('prevent-scroll');
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    withMapModalView: withMapModalView
  }, /*#__PURE__*/React.createElement("div", {
    className: "m114-im-listing imfilters-padding ".concat(listingView ? 'view-as-list' : '')
  }, loading ? null : /*#__PURE__*/React.createElement(React.Fragment, null, !listingItems.length ? noItemsDictionary : renderContent(), renderViewAsList && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "m114-im-listing__toggle ".concat(listingView ? 'listing-view' : '', "\n                ").concat(withMapModalView ? 'modal-view' : ''),
    onClick: function onClick() {
      if (canUseDOM && !listingView) {
        window.scrollTo(0, 0);
      }
      toggleOverflowOnBody();
      setListingView(!listingView);
      if (toggleMobileListingView) {
        toggleMobileListingView(!listingView);
      }
      tealiumClickFunc(tealiumMergeClickData(analytics['mapButtonAnalytics'], params), !listingView ? viewAsListingDictionary : viewAsMapDictionary);
    }
  }, !listingView ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.992",
    height: "14",
    viewBox: "0 0 18.992 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15417",
    "data-name": "Group 15417",
    transform: "translate(-122.531 -775.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: "12",
    transform: "translate(128.523 776.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: "7",
    transform: "translate(128.523 782.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: "10",
    transform: "translate(128.523 788.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x1: "0.992",
    transform: "translate(123.531 776.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x1: "0.992",
    transform: "translate(123.531 782.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x1: "0.992",
    transform: "translate(123.531 788.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }))) : /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14.27",
    height: "20.015",
    viewBox: "0 0 14.27 20.015"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: "14.27",
    height: "20.015",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    "clip-path": "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M10.42,13.826a3.437,3.437,0,1,0-3.445-3.46,3.449,3.449,0,0,0,3.445,3.46m0-5.6a2.129,2.129,0,0,1,2.159,2.145,2.167,2.167,0,1,1-4.333,0A2.137,2.137,0,0,1,10.42,8.221",
    transform: "translate(-3.278 -3.266)",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M12.357,2.282A7.206,7.206,0,0,0,7.142,0a7.226,7.226,0,0,0-5.23,2.289,6.88,6.88,0,0,0-1.9,5.172A8.453,8.453,0,0,0,.17,8.625L.418,9.6a22.409,22.409,0,0,0,2.719,5.518,36.834,36.834,0,0,0,3.549,4.706.63.63,0,0,0,.456.193A.644.644,0,0,0,7.6,19.82a36.918,36.918,0,0,0,3.534-4.705c1.977-3.082,3-5.586,3.124-7.654a6.891,6.891,0,0,0-1.9-5.18M7.142,1.27a5.926,5.926,0,0,1,4.286,1.882,5.629,5.629,0,0,1,1.559,4.23c-.146,2.4-1.9,5.449-2.926,7.055A36.686,36.686,0,0,1,7.142,18.4a36.117,36.117,0,0,1-2.934-3.958c-1.03-1.607-2.78-4.659-2.926-7.055A5.622,5.622,0,0,1,2.841,3.16a5.946,5.946,0,0,1,4.3-1.89",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }))), !listingView ? viewAsListingDictionary : viewAsMapDictionary))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    withMapModalView = _ref3.withMapModalView;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, "  ").concat(withMapModalView ? 'modal-view' : '')
  }, children);
};
var commonStyles = "cx4pvil";
var ltrStyles = "l1be5bx7";
var rtlStyles = "r19bfi15";
export default InteractiveMapListing;